"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _types = _interopRequireDefault(require("../../types"));

var _excluded = ["canDeselect", "children", "isDisabled", "onChange", "size"];
var propTypes = {
  /** Can deselect any radio */
  canDeselect: _propTypes["default"].bool,

  /** The individual radio items. */
  children: _propTypes["default"].node,

  /** Are all radios disabled */
  isDisabled: _propTypes["default"].bool,

  /** On change of radio selection. */
  onChange: _propTypes["default"].func.isRequired,

  /** The size for all radio components. */
  size: _propTypes["default"].oneOf([_types["default"].size.SMALL, _types["default"].size.MEDIUM, _types["default"].size.LARGE])
};
var defaultProps = {
  canDeselect: false,
  children: null,
  isDisabled: false,
  size: _types["default"].size.MEDIUM
};

var Group = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var canDeselect = props.canDeselect,
      children = props.children,
      isDisabled = props.isDisabled,
      onChange = props.onChange,
      size = props.size,
      moreGroupProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var defaultCheckedIndex = _react["default"].Children.toArray(children).findIndex(function (child) {
    return child.props.defaultIsChecked;
  });

  var selectedIndex = _react["default"].Children.toArray(children).findIndex(function (child) {
    return child.props.isChecked;
  });

  var _React$useState = _react["default"].useState(function () {
    return "radio-group_".concat((0, _uuid.v4)());
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 1),
      generatedName = _React$useState2[0];

  var _React$useState3 = _react["default"].useState(defaultCheckedIndex),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      checkedIndex = _React$useState4[0],
      setCheckedIndex = _React$useState4[1];

  if (selectedIndex !== -1 && selectedIndex !== checkedIndex) {
    setCheckedIndex(selectedIndex);
  }

  var getDeselectableIndex = function getDeselectableIndex(index) {
    return checkedIndex === index ? null : index;
  };

  var handleRadioClick = function handleRadioClick(index) {
    onChange(index);
    setCheckedIndex(canDeselect ? getDeselectableIndex(index) : index);
  };

  _react["default"].useImperativeHandle(ref, function () {
    return {
      updateCheckedIndex: function updateCheckedIndex(index) {
        setCheckedIndex(index);
      }
    };
  });

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-pka-anchor": "radio.group"
  }, moreGroupProps), _react["default"].Children.map(children, function (child, index) {
    if (child && child.type && child.type.displayName === "Radio") {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        onClick: function onClick() {
          return handleRadioClick(index);
        },
        isChecked: checkedIndex === index,
        isDisabled: isDisabled || child.props.isDisabled,
        canDeselect: canDeselect,
        size: size,
        name: child.props.name || generatedName,
        key: child.props.name || generatedName
      });
    }

    return child;
  }));
});

Group.displayName = "Radio.Group";
Group.propTypes = propTypes;
Group.defaultProps = defaultProps;
var _default = Group;
exports["default"] = _default;
//# sourceMappingURL=Group.js.map